export default __webpack_public_path__ + "static/media/transfer.dbf70409.gif";